import axiosInstance from 'services/axiosInstance';
import {
  IAutocomplete,
  IGetSecureDataRequestTextResponse,
  IGetSecureDataRequestTextVariablesResponse,
} from 'services/connectwise/types';
import { IRequest } from 'services/pod/types';
import {
  ICheckSecureDataPayload,
  ICreateSecureDataParams,
  ICreateSecureLinkPayload,
  IGenerateRequestPayload,
  ISecureDataSettings,
  ISecureFileSendPayload,
  ISendSecureDataPayload,
} from 'services/secureDataSharing/types';
import { ICommonResponse, IResponse } from 'services/types';

export const getSecureDataSettings = (): IResponse<ISecureDataSettings> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataSettings',
  });

export const getSecureDataRequestText = (): IResponse<IGetSecureDataRequestTextResponse[]> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataRequestText',
  });

export const createSecureDataLink = (
  payload: ICreateSecureLinkPayload,
): IResponse<ICommonResponse<string>> =>
  axiosInstance.request({
    method: 'POST',
    url: '/SecureData',
    data: payload,
  });
export const generateSecureData = (

  params: ICreateSecureDataParams,
): IResponse<ICommonResponse<string>> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureData/generate',
    params,
  });

export const sendSecureData = (payload: ISendSecureDataPayload): IResponse<boolean> =>
  axiosInstance.request({
    method: 'POST',
    data: payload,
    url: '/SecureData/send',
  });

export const sendSecureDataRequest = (payload: ISendSecureDataPayload): IResponse<boolean> =>
  axiosInstance.request({
    method: 'POST',
    data: payload,
    url: '/SecureDataRequest/send',
  });

export const sendSecureFile = (
  payload: ISecureFileSendPayload,
): IResponse<ICommonResponse<string>> => axiosInstance.postForm('/SecureData/file', payload);

export const getSecureDataLocations = (): IResponse<Array<IAutocomplete<number>>> =>
  axiosInstance.get('/SecureData/fileLocations');

export const generateRequest = (
  payload: IGenerateRequestPayload,
): IResponse<ICommonResponse<string>> =>
  axiosInstance.request({
    method: 'POST',
    url: '/SecureDataRequest/generateRequest',
    data: payload,
  });

export const checkSecureData = (
  payload: ICheckSecureDataPayload,
): IResponse<ICommonResponse<boolean>> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataRequest/check',
    params: payload,
  });

export const getSecureDataRequestTextVariables = (
  crmId: number | undefined,
  psaContactId?: string | undefined,
): IResponse<IGetSecureDataRequestTextVariablesResponse> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataRequest/getTextVariables',
    params: {
      CrmId: crmId,
      PsaContactId: psaContactId,
    },
  });

export const getSecureDataRequestSettings = (): IResponse<ISecureDataSettings> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataRequestSettings',
  });

export const getSecureDataRequests = (params: {
  _start: number;
  _end: number;
  ticketId?: string;
  _order?: string;
}): IResponse<any[]> =>
  axiosInstance.request({
    method: 'GET',
    url: '/SecureDataRequest/requests',
    params,
  });

export const checkSecureDataRequest = (requestId: string): IResponse<IRequest> =>
  axiosInstance.request({
    method: 'GET',
    url: `/SecureDataRequest/${requestId}/check`,
  });
